
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".5","d":"M24.355 21.08c.309.27.6.561.87.87l3.132-2.925a13.645 13.645 0 00-5.01-3.568l-3.479 3.479a9.348 9.348 0 014.487 2.144zM18.135 28.546l4.5-4.194a5.974 5.974 0 00-6.49-1.692l-2.085 2.088 4.075 3.798zM29.005 9.8l-3.168 3.169c1.21.618 2.34 1.382 3.364 2.274a16.91 16.91 0 011.555 1.555l3.132-2.925A21.028 21.028 0 0029.005 9.8zM27.997 7.816l1.276-1.276-1.59-1.59-2.89 2.889a20.88 20.88 0 00-22.408 6.037L5.517 16.8a16.754 16.754 0 0115.726-5.41l-3.015 3.014h-.09a13.66 13.66 0 00-10.22 4.628l2.934 2.746-3.859 3.858 1.496 1.499.095.092L27.997 7.816z","fill":"#6C7684"}})])
          )
        }
      }
    